import { Component } from "@angular/core";
import { AppMaterialModule } from "../../material/app-material.module";

@Component({
  selector: "app-informational-modal",
  standalone: true,
  imports: [AppMaterialModule],
  templateUrl: "./informational-modal.component.html",
  styleUrl: "./informational-modal.component.scss",
})
export class InformationalModalComponent {}
